import { FirestoreDB } from "./include/creds";
import {
  DocPath,
  DataProblem,
  GetDocResult,
  RemoveDocResult,
} from "./include/misc";

import {
  collection,
  doc,
  setDoc,
  getDoc,
  deleteDoc,
} from "firebase/firestore";

export type fs45RecentRemovedQueueEntries = {
  conversation_uid: string;
  consumer_contact_uid: string;
};

export function getDataProblems_fs45RecentRemovedQueueEntries(
  data: fs45RecentRemovedQueueEntries
): DataProblem[] {
  const dataproblems: DataProblem[] = [];
  return dataproblems;
}

export function isValidData(data: fs45RecentRemovedQueueEntries): boolean {
  return true;
}

export async function getDocFrom_fs45RecentRemovedQueueEntries(
  fs1_id: string,
  fs2_id: string,
  fs27_consumer_uid: string,
  fs27_conversation_uid: string,  
): Promise<GetDocResult> {
  const result: GetDocResult = {
    debug_data: [],
    return_msg:
      "fs45RecentRemovedQueueEntries:getDocFrom_fs45RecentRemovedQueueEntries ",
    success: true,
    doc_data: {},
  };

  if (!fs1_id || !fs2_id || !fs27_consumer_uid || !fs27_conversation_uid) {
    result.success = false;
    result.return_msg += "Invalid function arguments.";
    return await Promise.resolve(result);
  }

  const doc_ref = doc(
    collection(
      FirestoreDB,
      "fs1RecyclerBusiness",
      fs1_id,
      "fs2RecyclerLocation",
      fs2_id,
      "fs45RecentRemovedQueueEntries",
      fs27_consumer_uid + "-" + fs27_conversation_uid
    )
  );

  const doc_data = (await getDoc(doc_ref)).data();
  if (doc_data === undefined) {
    result.success = false;
    result.return_msg +=
      "Could not find a document with the passed-in path arguments.";
    return await Promise.resolve(result);
  }

  result.doc_data = doc_data;
  return await Promise.resolve(result);
}

export async function setDocIn_fs45RecentRemovedQueueEntries(
  fs1_id: string,
  fs2_id: string,
  fs27_consumer_contact_uid: string,
  fs27_conversation_uid: string,
  data: fs45RecentRemovedQueueEntries
): Promise<DocPath> {
  const result: DocPath = {
    id: "",
    path: "",
  };
  if (!isValidData(data)) {
    return await Promise.resolve(result);
  }

  const collectionRef = collection(
    FirestoreDB,
    "fs1RecyclerBusiness",
    fs1_id,
    "fs2RecyclerLocation",
    fs2_id,
    "fs45RecentRemovedQueueEntries"
  )

  const doc_ref = doc(collectionRef, fs27_consumer_contact_uid + "-" + fs27_conversation_uid);

  await setDoc(doc_ref, data);

  result.id = doc_ref.id;
  result.path = doc_ref.path;
  return await Promise.resolve(result);
}

export async function removeDocFrom_fs45RecentRemovedQueueEntries(
  fs1_id: string,
  fs2_id: string,
  fs27_consumer_contact_uid: string,
  fs27_conversation_uid: string
): Promise<RemoveDocResult> {
  const result: RemoveDocResult = {
    debug_data: [],
    return_msg:
      "fs45RecentRemovedQueueEntries:removeDocFrom_fs45RecentRemovedQueueEntries ",
    success: true,
  };

  if (!fs1_id || !fs2_id || !fs27_consumer_contact_uid || !fs27_conversation_uid) {
    result.success = false;
    result.return_msg += "Invalid function arguments.";
    return await Promise.resolve(result);
  }

  const doc_ref = doc(
    collection(
      FirestoreDB,
      "fs1RecyclerBusiness",
      fs1_id,
      "fs2RecyclerLocation",
      fs2_id,
      "fs45RecentRemovedQueueEntries"
    ),
    fs27_consumer_contact_uid + "-" + fs27_conversation_uid
  );

  await deleteDoc(doc_ref);
  return await Promise.resolve(result);
}
